import React from 'react'

const Footer = () => {

  const style={
    p:{
      position: 'fixed',
      bottom:'-55px',
      right: '-70px',
      color:'white',
      minWidth: '20rem',
      minHeight:'5rem', 
      textShadow: '2px 2px #330033',
      fontSize:'0.8rem',

    },
  strong:{
    color:'#f8c428',
  }
  }
  return (
    <div className='footer'>
      <p 
      style={style.p}
      >Craft by <strong style={style.strong}>Ahmed</strong>👨🏻‍💻 </p>
    </div>
  )
}

export default Footer;
